import CONTENT_HEADER from '../plugins/content_header'
import GET_ARTICLES from '../plugins/getArticles'
const [w,d,l] = [window,document,location]
const is_mobileUI = () =>  d.documentElement.classList.contains('ui-mobile')

export default function NEWS() {
  
  CONTENT_HEADER();
  
  $(() => {
    // リスト・詳細コンテナのクラス変更
    const cat_container = d.querySelector('.layout_b_pattern6')
    const list_container = d.querySelector('#main>.element_list')
    const detail_container = d.querySelector('.element_detail')

    if(l.search.match(/article=(\d+)/)){
      detail_container.classList.remove('element_detail');
      detail_container.classList.add('p-news__detail');
      const id = l.search.match(/article=(\d+)/)[1]
      $('.detail_title .hs_entrytitle').attr({
        'data-plugin':"getArticles",
        'data-content': "news",
        'data-articles': id,
        'data-amount': 1,
      });
      $('.catetitle').insertAfter('.breadcrumbs')
      GET_ARTICLES('[data-plugin="getArticles"]',{
        makeItem(item,opt){
          const newitem = (item.is_new)? 'NEW':''
          return $(`
          <div class="titleinner">
            <small class="date">${item.date}</small>
            <strong class="title">${item.title}</strong>
            <small class="new">${newitem}</small>
          </div>`)[0]
        }
      })
    }else{
      list_container.classList.remove('element_list');
      list_container.classList.add('p-news__list');
    }
    cat_container.classList.remove('layout_b_pattern6');
    cat_container.classList.add('p-news__category');
    $('.paginationbox').appendTo('#container')

    // 記事リスト整形
    $('.artloop','.p-news__list').each((i,v)=>{
      const wrapLink = $(v).parent('a.wrapLink')[0]
      wrapLink.href = wrapLink.href.replace('main.php','')
      const catetitle = $('.catetitle a',v)[0]

      // ボタン挿入
      if(catetitle!=undefined){
        $(`<a href="${catetitle.href.replace('main.php','')}" class="catbtn button button-small button-senary">${catetitle.innerHTML}</a>`).insertAfter( $('.cover-thumb',v) )
      }

      // デフォルト表示カテゴリ名を削除
      $('.catetitle',v).remove()

    })

    if( is_mobileUI() && d.querySelectorAll('#hybsMob > .listContents').length == 0 ){
      $('.listpageLinkA','#footer').remove()
      $('.detailFooter').append(`<a class="p-list__backBtn icon-list" href="/news/" rel="external" title="記事一覧に戻る">記事一覧に戻る</a>`);
    }

  })
}